// extracted by mini-css-extract-plugin
export default {"wrapper":"Advantages_wrapper__HwvQb","title":"Advantages_title__GWezW","description":"Advantages_description__zVnhc","decriptionCard":"Advantages_decriptionCard__vQMfh"};